import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { partnerNames } from "../../data/site";
export function PartnerMarquee() {
  const reduce = useReducedMotion();
  const items = [...partnerNames, ...partnerNames, ...partnerNames];
  return <div className="overflow-hidden bg-ink py-5 text-sun" aria-label="In partnership with Link School of Business, Mahindra University and Circuit Launch" data-id="element-578" data-mp="2re9asd46tynb">
      <motion.div className="flex w-max gap-10 whitespace-nowrap font-display text-3xl uppercase md:text-5xl" animate={reduce ? undefined : {
      x: ["0%", "-33.333%"]
    }} transition={{
      duration: 22,
      ease: "linear",
      repeat: Infinity
    }} aria-hidden="true" data-id="element-579" data-mp="1zqh5mjusx7vg">
        {[...items, ...items].map((name, i) => <span key={i} className="flex items-center gap-10" data-id="element-580" data-mp="23p6jsennytg5" data-mpi={i}>
            {name}
            <span className="text-tomato" data-id="element-581" data-mp="1fzm0tvrifw6v">✶</span>
          </span>)}
      </motion.div>
    </div>;
}